module.exports = __webpack_public_path__ + "public/SiteIcons/reservationEdit.svg?0fe4d268";